import React, { Component } from 'react';
import { Tabs } from 'antd';
import Personal from './Personal';
import SideNav from "../SideNav";
import Business from './Business';
import Regional from './Regional';

const { TabPane } = Tabs;

class IncomeReport extends Component {
    state = {
        panes: [{
            title: '个人收入报告',
            key: 'Personal',
            content: null,
        }],
        activeKey: 'Personal',
    }

    componentDidMount() {
        const { panes } = this.state;
        const { curRole } = sessionStorage;
        const canCheck = curRole === 'BO' || curRole === 'FIN' || curRole === 'HRRC';
        if (canCheck) {
            panes.push({
                title: '业务线收入报告',
                key: 'Business',
                content: null,
            }, {
                title: '区域管理收入报告',
                key: 'Regional',
                content: null,
            })
        };
        this.setState({ panes },() => {
            this.updatePanes();
        });
    }

    updatePanes = () => {
        const { panes, activeKey } = this.state;
        let RenderContent = null;
        if (activeKey == 'Personal') {
            RenderContent = Personal;
        } else if (activeKey == 'Business') {
            RenderContent = Business;
        } else if (activeKey == 'Regional') {
            RenderContent = Regional;
        }
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.updatePanes();
        });
    }

    render() {
        const { panes, activeKey } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="IncomeReport" />
                <div className="main">
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                        {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)}
                    </Tabs>
                </div>
            </div>
        );
    }
}

export default IncomeReport;



// WEBPACK FOOTER //
// ./src/components/financeManagement/IncomeReport/index.js